import apiClient from '@/services/AccountClient'
import PageableApiRequest from '@/services/ApiRequests/PageableApiRequest'
import CountryGroup from '@/models/CountryGroup'
import CountryGroupsApi from '@/services/Api/CountryGroupsApi'

export const COUNTRY_GROUPS = {
  EU: 'EU',
  NON_EU: 'NON_EU',
  EEA: 'EEA',
  NON_EEA: 'NON_EEA',
  NO_INFO_EXCHANGE: 'NO_INFO_EXCHANGE',
  CIS: 'CIS',
  DHL: 'DHL',
  RU_BY: 'RU_BY',
  ALLOWED: 'ALLOWED',
  UK: 'UK',
  PKS: 'PKS',
  NON_UPS: 'NON_UPS',
  OECD_NON_EU: 'OECD_NON_EU',
  DEPOSITS_EEA: 'DEPOSITS_EEA',
  DEPOSITS_EU: 'DEPOSITS_EU',
  NON_SEPA: 'NON_SEPA',
  SEPA: 'SEPA',
  BLOCKED_CARD_TOPUPS: 'BLOCKED_CARD_TOPUPS',
  US: 'US',
  NON_US: 'NON_US'
}

export const COUNTRY_GROUP_IDS = {
  [COUNTRY_GROUPS.EU]: 1,
  [COUNTRY_GROUPS.EEA]: 2,
  [COUNTRY_GROUPS.NON_EU]: 4,
  [COUNTRY_GROUPS.NON_EEA]: 5,
  [COUNTRY_GROUPS.NO_INFO_EXCHANGE]: 7,
  [COUNTRY_GROUPS.CIS]: 8,
  [COUNTRY_GROUPS.DHL]: 9,
  [COUNTRY_GROUPS.RU_BY]: 13,
  [COUNTRY_GROUPS.ALLOWED]: 15,
  [COUNTRY_GROUPS.UK]: 16,
  [COUNTRY_GROUPS.PKS]: 18,
  [COUNTRY_GROUPS.NON_UPS]: 14,
  [COUNTRY_GROUPS.OECD_NON_EU]: 10,
  [COUNTRY_GROUPS.DEPOSITS_EEA]: 12,
  [COUNTRY_GROUPS.DEPOSITS_EU]: 11,
  [COUNTRY_GROUPS.SEPA]: 3,
  [COUNTRY_GROUPS.NON_SEPA]: 6,
  [COUNTRY_GROUPS.BLOCKED_CARD_TOPUPS]: 19,
  [COUNTRY_GROUPS.US]: 21,
  [COUNTRY_GROUPS.NON_US]: 22
}

export const COUNTRY_GROUP_CATEGORIES = {
  CARD_DELIVERY: [COUNTRY_GROUPS.DHL, COUNTRY_GROUPS.NON_UPS],
  FEES: [COUNTRY_GROUPS.EEA, COUNTRY_GROUPS.NON_EEA, COUNTRY_GROUPS.NO_INFO_EXCHANGE, COUNTRY_GROUPS.RU_BY, COUNTRY_GROUPS.UK],
  SAVINGS: [COUNTRY_GROUPS.OECD_NON_EU, COUNTRY_GROUPS.DEPOSITS_EU, COUNTRY_GROUPS.DEPOSITS_EEA],
  GENERIC: [COUNTRY_GROUPS.EU, COUNTRY_GROUPS.SEPA, COUNTRY_GROUPS.NON_EU, COUNTRY_GROUPS.NON_SEPA, COUNTRY_GROUPS.CIS, COUNTRY_GROUPS.BLOCKED_CARD_TOPUPS]
}

const economicAreaOptions = [
  {
    name: 'EEA (European Economic Area)',
    value: COUNTRY_GROUPS.EEA,
    countryGroupId: COUNTRY_GROUP_IDS.EEA,
    countryCodes: null
  },
  {
    name: 'NON-EEA (NON-European Economic Area)',
    value: COUNTRY_GROUPS.NON_EEA,
    countryGroupId: COUNTRY_GROUP_IDS.NON_EEA,
    countryCodes: null
  },
  {
    name: 'Countries not supporting information exchange',
    value: COUNTRY_GROUPS.NO_INFO_EXCHANGE,
    countryGroupId: COUNTRY_GROUP_IDS.NO_INFO_EXCHANGE,
    countryCodes: null
  },
  {
    name: 'Russia & Belarus',
    value: COUNTRY_GROUPS.RU_BY,
    countryGroupId: COUNTRY_GROUP_IDS.RU_BY,
    countryCodes: null
  },
  {
    name: 'UK',
    value: COUNTRY_GROUPS.UK,
    countryGroupId: COUNTRY_GROUP_IDS.UK,
    countryCodes: null
  },
  {
    name: 'US',
    value: COUNTRY_GROUPS.US,
    countryGroupId: COUNTRY_GROUP_IDS.US,
    countryCodes: null
  },
  {
    name: 'Non US',
    value: COUNTRY_GROUPS.NON_US,
    countryGroupId: COUNTRY_GROUP_IDS.NON_US,
    countryCodes: null
  }
]

const state = () => ({
  residenceOptions: [
    {
      name: 'EU resident',
      value: COUNTRY_GROUPS.EU,
      countryGroupId: COUNTRY_GROUP_IDS.EU
    },
    {
      name: 'NON-EU resident',
      value: COUNTRY_GROUPS.NON_EU,
      countryGroupId: COUNTRY_GROUP_IDS.NON_EU
    },
    {
      name: 'Russia & Belarus resident',
      value: COUNTRY_GROUPS.RU_BY,
      countryGroupId: COUNTRY_GROUP_IDS.RU_BY
    },
    {
      name: 'US',
      value: COUNTRY_GROUPS.US,
      countryGroupId: COUNTRY_GROUP_IDS.US
    },
    {
      name: 'Non US',
      value: COUNTRY_GROUPS.NON_US,
      countryGroupId: COUNTRY_GROUP_IDS.NON_US
    }
  ],
  economicAreaOptions: [
    {
      name: 'EEA (European Economic Area)',
      value: COUNTRY_GROUPS.EEA,
      countryGroupId: COUNTRY_GROUP_IDS.EEA,
      countryCodes: null
    },
    {
      name: 'NON-EEA (NON-European Economic Area)',
      value: COUNTRY_GROUPS.NON_EEA,
      countryGroupId: COUNTRY_GROUP_IDS.NON_EEA,
      countryCodes: null
    },
    {
      name: 'Countries not supporting information exchange',
      value: COUNTRY_GROUPS.NO_INFO_EXCHANGE,
      countryGroupId: COUNTRY_GROUP_IDS.NO_INFO_EXCHANGE,
      countryCodes: null
    },
    {
      name: 'Russia & Belarus',
      value: COUNTRY_GROUPS.RU_BY,
      countryGroupId: COUNTRY_GROUP_IDS.RU_BY,
      countryCodes: null
    },
    {
      name: 'UK',
      value: COUNTRY_GROUPS.UK,
      countryGroupId: COUNTRY_GROUP_IDS.UK,
      countryCodes: null
    },
    {
      name: 'US',
      value: COUNTRY_GROUPS.US,
      countryGroupId: COUNTRY_GROUP_IDS.US,
      countryCodes: null
    },
    {
      name: 'Non US',
      value: COUNTRY_GROUPS.NON_US,
      countryGroupId: COUNTRY_GROUP_IDS.NON_US,
      countryCodes: null
    }
  ],
  countryGroups: [],
  countryGroupsLoaded: false,
  countryNames: {}
})

const getters = {
  residenceOptions: (state) => {
    return state.residenceOptions
  },
  economicAreaOptions: (state) => {
    return economicAreaOptions.map((economicAreaOption, index) => {
      const economicAreaCountryGroup = state.countryGroups.find(
        group => group.id === economicAreaOption.countryGroupId
      )

      return economicAreaCountryGroup != null
        ? { ...economicAreaOption, countryCodes: economicAreaCountryGroup.countryCodes }
        : economicAreaOption
    })
  },
  cisCountries: (state) => {
    return state.countryGroups.find(({ id }) => id === COUNTRY_GROUP_IDS.CIS).countryCodes
  },
  dhlCountries: (state) => {
    return state.countryGroups.find(({ id }) => id === COUNTRY_GROUP_IDS.DHL).countryCodes
  },
  pksCountries: (state) => {
    return state.countryGroups.find(({ id }) => id === COUNTRY_GROUP_IDS.PKS).countryCodes
  },
  allowedCountries: (state) => {
    return state.countryGroups.find(({ id }) => id === COUNTRY_GROUP_IDS.ALLOWED).countryCodes
  },
  countryGroupsLoaded: (state) => {
    return state.countryGroupsLoaded
  },
  countryNames: (state) => {
    return state.countryNames
  },
  countryGroups: (state) => {
    return state.countryGroups
  }
}

const actions = {
  loadCountryGroupsAndCountryNames ({ commit }) {
    const countryGroups = new PageableApiRequest(
      CountryGroupsApi.fetchAll, CountryGroup
    )

    return Promise.all([
      countryGroups.execute(),
      apiClient.sendRequest('GET', 'api/v1/countries')
    ])
      .then(([countryGroups, { payload: countryNames }]) => {
        commit('setCountryGroups', countryGroups)
        commit('setCountryNames', countryNames)
        commit('setCountryGroupsLoaded')
      })
  }
}

const mutations = {
  setCountryGroups (state, countryGroups) {
    state.countryGroups = countryGroups
  },
  setCountryNames (state, countryNames) {
    state.countryNames = countryNames
  },
  setCountryGroupsLoaded (state) {
    state.countryGroupsLoaded = true
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
